export default "__VITE_ASSET__2K1qoexL__"